<script>

  import {to, API} from "@API";
  import {getContext, onMount, onDestroy } from "svelte";
  import CustomerInfo from "@components/CustomerInformation.svelte";

  let BindUserPurchase = API.service('shop/bind_user_purchase/');

  let completedPurchase = false;
  let customerProduct;
  let paymentIntentData;
  let productChoosen = false;
  let purchaseError;
  let bindingUser = false;

  let transition = { y: 200, duration: 2000 }

  let {org, product, matchkey, shopData} = getContext("SHOP");
  let container;
  let introAnimation;
  let extroAnimation;

  export let step;
  export let stepComplete

  let OrderService = API.service('shop/orders/createUserOrder');
  OrderService.host(org.api);

  onMount(()=>{
    if(window.posthog){
      window.posthog.capture('store-purchase-entry', { value: true });
    }
  });

  onDestroy(()=>{});

  async function onCompletePurchase(event) {
    bindingUser = true

    if(matchkey && matchkey.researchInvite){
        completedPurchase = true;
        $shopData.purchaseComplete = true;
        $shopData = $shopData;
        stepComplete()
    }else{
      let {subscription, paymentIntent} = event.detail;

      let data = {
        org:org.guid,
        location:$shopData.location,
        subscription:subscription,
        purchase:paymentIntent,
        product:product,
        ...($shopData.serviceProvider ? {service_provider: $shopData.serviceProvider.guid} : {}),
        ...(matchkey ? {invite_key:matchkey.invite_key} : {}),
      }
      if($shopData.price.guid) {
        data.tier = $shopData.price.guid
      }

      if(!$shopData.remove_belt && $shopData.beltSizes.length){
        let belts = $shopData.beltSizes.map(b => {
          return {qty:1, sku:b}
        });
        data = {
          ...data,
          ...{
            pickup_location:$shopData.pick_up_location,
            equipment: shopData.remove_belt ? [] : [{qty:($shopData.productType === 'couple' ? 2 : 1),sku:'electrodes-50'},...belts]
          }
        }
      }
      let [error,response] = await to(BindUserPurchase.post(data));

      if(response){
        $shopData.purchaseComplete = true;
        $shopData = $shopData;
        stepComplete();
        if(window.posthog){
          window.posthog.capture('store-purchase-complete', { value: true });
        }
        //window.Marketing.addTagsToUser({active_lead: false, active_customer:true});
      }else{
        purchaseError = "There was an error completing your purchase. Please contact OTO support at support@oto.coach for assistance";
      }
    }
  }

</script>

<style type="text/scss">

  .customer-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    background:white;
    @media screen and (min-width:1200px){
      justify-content: center;
      background:transparent;
    }
    @media screen and (max-width:1200px){
      padding-bottom: 30px;
    }
  }

  .purchase-success {
    width: 300px;
    text-align: center;
    display: flex;
    flex-direction: column;
  }


  /* Only center when the viewport is tall enough; justify-center + overflow
     clips the top of the Stripe Payment Element on normal desktop heights. */
  .content-holder{
    justify-content: flex-start;
    @media screen and (min-height:1300px){
      justify-content: center;
    }
  }


</style>

<div class="content-holder flex items-center flex-col md:h-full w-full py-6">
    {#if !bindingUser}
      <CustomerInfo showBackOnOne={false} on:back on:updatePrice on:completeSkipBind={e =>{completedPurchase=true}} on:complete={onCompletePurchase}/>
    {:else}
      {#if bindingUser && !purchaseError}
        <div class="purchase-success mt-5">
          <i class="fa-duotone text-5xl fa-truck-ramp-box"></i>
          <span class="text-xl mt-3">
            Please wait.. We are processing your order.
          </span>
          <p class="mt-3 text-gray-400 text-base text-center">This may take a minute.</p>
        </div>
      {/if}

      {#if purchaseError}
        <div class="bg-red-50 p-4 text-red-500 font-bold rounded-md">{purchaseError}</div>
      {/if}
    {/if}

</div>
